// import "./TypingIndicator.css";

export default function TypingIndicator() {
  return (
    <div className="typing-indicator">
      <div className="ellipse"></div>
      <div className="ellipse"></div>
      <div className="ellipse"></div>
    </div>
  );
}
